export enum TabsItemLabel {
  DUPLICATE = 'Duplicate',
  RENAME = 'Rename',
  REMOVE = 'Remove',
  PIN_TO_DASHBOARDS = 'Pin to dashboards',
}
